<template>
  <div class="page_content dd_pg">
    <div v-if="!getExtraChance" class="dd_carousel">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <h1>Gefeliciteerd!</h1>
            <h2>Kies je cadeau:</h2>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="swiper_dd d-flex flex-column flex-lg-row flex-md-row justify-content-center">
          <input v-if="JSON.stringify(voiceReward)!=='{}'" type="radio" id="voice"
                 name="radio-group"
                 v-model="selectedTelcoReward" :value="voiceReward.id">
          <label v-if="JSON.stringify(voiceReward)!=='{}'" for="voice"
                 class="swiper-slide d-flex flex-row flex-lg-column flex-md-column mx-0 mx-lg-4 mx-md-2">
            <div class="container">
              <div class="row justify-content-end">
                <div class="col-1 col-lg-0 col-md-0 p-0"></div>
                <div class="d-flex flex-row-reverse flex-lg-column flex-md-column w-100">
                  <div class="col-5 col-lg-12 col-md-12">
                    <img :src="voiceReward.image" alt="">
                  </div>
                  <div class="col-5 col-lg-12 col-md-12 align-self-center p-0">
                    <p class="">{{ voiceReward.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </label>
          <input v-if="JSON.stringify(messageReward)!=='{}'" type="radio" id="message"
                 name="radio-group"
                 v-model="selectedTelcoReward" :value="messageReward.id">
          <label v-if="JSON.stringify(messageReward)!=='{}'" for="message"
                 class="swiper-slide d-flex flex-row flex-lg-column flex-md-column mx-0 mx-lg-4 mx-md-2">
            <div class="container">
              <div class="row justify-content-end">
                <div class="col-1 col-lg-0 col-md-0 p-0"></div>
                <div class="d-flex flex-row-reverse flex-lg-column flex-md-column w-100">
                  <div class="col-5 col-lg-12 col-md-12">
                    <img :src="messageReward.image" alt="">
                  </div>
                  <div class="col-5 col-lg-12 col-md-12 align-self-center p-0">
                    <p class="">{{ messageReward.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </label>

          <input v-if="JSON.stringify(euroReward)!=='{}'" type="radio" id="euro" name="radio-group"
                 v-model="selectedTelcoReward" :value="euroReward.id">
          <label v-if="JSON.stringify(euroReward)!=='{}'" for="euro"
                 class="swiper-slide d-flex flex-row flex-lg-column flex-md-column mx-0 mx-lg-4 mx-md-2">
            <div class="container">
              <div class="row justify-content-end">
                <div class="col-1 col-lg-0 col-md-0 p-0"></div>
                <div class="d-flex flex-row-reverse flex-lg-column flex-md-column w-100">
                  <div class="col-5 col-lg-12 col-md-12">
                    <img :src="euroReward.image" alt="">
                  </div>
                  <div class="col-5 col-lg-12 col-md-12 align-self-center p-0">
                    <p class="">{{ euroReward.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </label>

          <input v-if="JSON.stringify(dataReward)!=='{}'" type="radio" id="data" name="radio-group"
                 v-model="selectedTelcoReward" :value="dataReward.id">
          <label v-if="JSON.stringify(dataReward)!=='{}'" for="data"
                 class="swiper-slide d-flex flex-row flex-lg-column flex-md-column mx-0 mx-lg-4 mx-md-2">
            <div class="container">
              <div class="row justify-content-end">
                <div class="col-1 col-lg-0 col-md-0 p-0"></div>
                <div class="d-flex flex-row-reverse flex-lg-column flex-md-column w-100">
                  <div class="col-5 col-lg-12 col-md-12">
                    <img :src="dataReward.image" alt="">
                  </div>
                  <div class="col-5 col-lg-12 col-md-12 align-self-center p-0">
                    <p class="">{{ dataReward.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>

    <div class="container form_section">
      <div class="row justify-content-center">
        <div class="col-12 text-center m-top-80">
          <h1>Bezorgadres</h1>
          <h2>Stuur mijn prijs op naar dit adres</h2>
        </div>
      </div>

      <form>
        <div class="row">
          <div class="col-12 col-lg-3 col-md-6 space_btn_inputs">
            <div class="form-group" for="title">
              <p class="form_title_input">Aanhef *</p>
              <select v-model="gender"
                      name="title"
                      id="title"
                      class="custom-select_drop"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :showLabels="false"
                      :selected="this.getDeliveryDetails.gender">
                <option disabled>Aanhef *</option>
                <option>Dhr.</option>
                <option>Mevr.</option>
              </select>
            </div>
            <div v-if="!isValidGender" class="error_msg">
              Kies je aanhef
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-6 space_btn_inputs">
            <div :class="{'form-group': true, 'error': !this.isValidFirstname}">
              <p class="form_title_input" for="first-name">Voornaam*</p>
              <input v-model="firstname" type="text" class="form-control" id="first-name"
                     name="first-name"
                     required/>
              <div v-if="!isValidFirstname" class="error_msg">
                Ongeldige voornaam (het moet minstens 2 geldige karakters bevatten).
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-5 col-md-12 space_btn_inputs last">
            <div :class="{'form-group': true, 'error': !this.isValidLastname}">
              <p class="form_title_input" for="last-name">Achternaam*</p>
              <input v-model="lastname" type="text" class="form-control" id="last-name"
                     name="last-name"
                     required/>
              <div v-if="!isValidLastname" class="error_msg">
                Ongeldige achternaam (het moet ten minste 2 geldige karakters bevatten).
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-5 col-md-5 space_btn_inputs">
            <div :class="{'form-group': true, 'error': !this.isValidMsisdn}">
              <p class="form_title_input" for="msisdn">Telefoonnummer*</p>
              <input v-model="msisdn" type="tel" class="form-control" id="msisdn" name="msisdn"/>
              <div v-if="!isValidMsisdn" class="error_msg">
                Ongeldig mobiele nummer. Je mobiele nummer moet beginnen met 06 en bestaat uit 10
                cijfers.
                Of beginnend met 097 en bestaand uit 12 cijfers.
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-7 col-md-7 space_btn_inputs last">
            <div :class="{'form-group': true, 'error': !this.isValidEmail}">
              <p class="form_title_input" for="email">Email*</p>
              <input v-model="email" type="email" class="form-control" id="email" name="email"
                     required/>
              <div v-if="!isValidEmail" class="error_msg">
                Ongeldig e-mailadres.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-6 col-md-6 space_btn_inputs">
            <div :class="{'form-group': true, 'error': !this.isValidPostalCode}">
              <p class="form_title_input" for="postcode">Postcode*</p>
              <input v-model="postalCode" type="text" class="form-control" id="postcode"
                     name="postcode"
                     @focusout="checkZipCodeFinder"/>
              <div v-if="!isValidPostalCode" class="error_msg">
                Geen geldige postcode ingevoerd, gebruik het format 1234 AB
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-md-6 space_btn_inputs last">
            <div :class="{'form-group': true, 'error': !this.isValidHouseNumber}">
              <p class="form_title_input" for="house_numb">Huisnr.*</p>
              <input v-model="houseNumber" type="text" class="form-control" id="house_numb"
                     name="house_numb"
                     required
                     @focusout="checkZipCodeFinder"/>
              <div v-if="!isValidHouseNumber" class="error_msg">
                Ongeldig huisnummer, format is max. 5 cijfers zonder spatie
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 space_btn_inputs last">
            <div :class="{'form-group': true, 'error': !this.isValidAddress}">
              <p class="form_title_input" for="address">Adres*</p>
              <input v-model="address" type="text" class="form-control" id="address" name="address"
                     required/>
              <div v-if="!isValidAddress" class="error_msg">
                Ongeldige straatnaam, (het moet ten minste 2 geldige karakters bevatten
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-8 col-md-6 space_btn_inputs">
            <div class="form-group">
              <p class="form_title_input" for="descr">Toevoeging</p>
              <input v-model="addressAddOn" type="text" class="form-control" id="descr" name="descr"/>
              <div v-if="!isValidAddressAddon" class="error_msg">
                Ongeldige toevoeging, format is max. 5 karakters, zonder spatie
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-6 space_btn_inputs last">
            <div :class="{'form-group': true, 'error': !this.isValidCity}">
              <p class="form_title_input" for="city">Woonplaats*</p>
              <input v-model="city" type="text" class="form-control" id="city" name="city"/>
              <div v-if="!isValidCity" class="error_msg">
                Ongeldige stad, (het moet ten minste 2 geldige karakters bevatten).
              </div>
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-12 space_btn_inputs last">
            <button type="button" @click="submitForm" class="blue_btn">Bevestigen</button>
          </div>
          <div v-if="chooseTelcoError" class="error_msg">
            Kies één van de 3 cadeaus hierboven
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-12 space_btn_inputs last">
            <div class="desc_text">
              Deze gegevens worden uitsluitend voor het verzenden van je prijs gebruikt.
              Telefoonnummer en
              e-mailadres zijn nodig om je eventueel te kunnen bereiken over het afleveren van je
              prijs.
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters, mapMutations} from 'vuex'
import gameFlow from '../common/mixin/gameFlow'
import router from '../router'

export default {
  name: 'DeliveryDetails',
  mixins: [
    gameFlow
  ],
  data() {
    return {
      voiceReward: {},
      messageReward: {},
      euroReward: {},
      dataReward: {},
      genderOptions: [
        'Frau',
        'Herr'
      ],
      gender: null,
      firstname: null,
      lastname: null,
      msisdn: null,
      email: null,
      postalCode: null,
      houseNumber: null,
      address: null,
      addressAddOn: null,
      city: null,
      isValidGender: true,
      isValidFirstname: true,
      isValidLastname: true,
      isValidMsisdn: true,
      isValidEmail: true,
      isValidPostalCode: true,
      isValidHouseNumber: true,
      isValidAddress: true,
      isValidAddressAddon: true,
      isValidCity: true,
      isDisabled: false,
      selectedTelcoReward: null,
      chooseTelcoError: false,
      zipCodeFinderPostalCode: false,
      zipCodeFinderHouseNumber: false
    }
  },
  computed: {
    ...mapGetters([
      'getGameResponse',
      'getSelectedCodeForRedemption',
      'getTelcoInfo',
      'getSelectedTelcoReward',
      'getDeliveryDetails',
      'getExtraChance',
      'getTelcoValidRewardIds'
    ])
  },
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0
    if (!this.getExtraChance) {
      if (this.getTelcoInfo.length === 0) {
        this.networkRewardInfo(this.getTelcoValidRewardIds, this.getSelectedCodeForRedemption)
          .then((response) => {
            this.$store.commit('updateTelcoInfo', response.data.customNetworkInfoApiList)
            this.createCarouselElements()
          })
      } else {
        this.createCarouselElements()
      }
    }

    if (this.getDeliveryDetails !== null) {
      this.gender = this.getDeliveryDetails.gender
      this.firstname = this.getDeliveryDetails.firstname
      this.lastname = this.getDeliveryDetails.lastname
      this.msisdn = this.getDeliveryDetails.msisdn
      this.email = this.getDeliveryDetails.email
      this.postalCode = this.getDeliveryDetails.postalCode
      this.houseNumber = this.getDeliveryDetails.houseNumber
      this.address = this.getDeliveryDetails.address
      if (this.getDeliveryDetails.addressAddOn !== null)
        this.addressAddOn = this.getDeliveryDetails.addressAddOn
      this.city = this.getDeliveryDetails.city
      if (!this.getExtraChance) {
        this.selectedTelcoReward = this.getSelectedTelcoReward
      }
    }
    this.setInGameFlow("true", this.$route.path.substring(1))
  },
  methods: {
    ...mapActions([
      'networkRewardInfo',
      'saveDeliveryData',
      'zipCodeFinder'
    ]),
    ...mapMutations([
      'updateGameResponse',
      'updateSelectedTelcoReward',
      'updateDeliveryDetails'
    ]),
    createCarouselElements() {
      this.getTelcoInfo.forEach(telco => {
        if (telco.telcoType === "VOICE") {
          this.voiceReward = telco
        } else if (telco.telcoType === "SMS") {
          this.messageReward = telco
        } else if (telco.telcoType === "FREE_RECHARGE") {
          this.euroReward = telco
        } else if (telco.telcoType === "DATA") {
          this.dataReward = telco
        }
      })
    },
    submitForm() {
      this.chooseTelcoError = (this.selectedTelcoReward === null || this.selectedTelcoReward.length === 0) && !this.getExtraChance;
      if (this.validateForm()) {
        if (!this.getExtraChance) {
          this.updateSelectedTelcoReward(this.selectedTelcoReward)
        }
        this.updateDeliveryDetails(this.createDeliveryData())
        router.push({name: 'DeliveryDetailsConfirmation'})
      }
    },
    validateForm() {
      this.isValidGender = !!this.gender
      this.isValidFirstname = !!this.firstname && this.validString(this.firstname)
      this.isValidLastname = !!this.lastname && this.validString(this.lastname)
      this.isValidMsisdn = !!this.msisdn && this.msisdnValidation(this.msisdn)
      this.isValidEmail = this.validEmail(this.email)
      this.isValidPostalCode = !!this.postalCode && this.validPostalCode(this.postalCode)
      this.isValidHouseNumber = !!this.houseNumber && this.validHouseNumber(this.houseNumber)
      this.isValidAddress = !!this.address && this.validAddress(this.address)
      this.isValidCity = !!this.city && this.validString(this.city)
      let validated;
      if (this.addressAddOn === undefined || this.addressAddOn === null || this.addressAddOn === '') {
        validated = this.isValidFirstname && this.isValidLastname && this.isValidMsisdn && this.isValidEmail && this.isValidPostalCode
          && this.isValidHouseNumber && this.isValidAddress && this.isValidCity && !this.chooseTelcoError
      } else {
        this.isValidAddressAddon = !!this.addressAddOn && this.validateAddressAddon(this.addressAddOn)
        validated = this.isValidFirstname && this.isValidLastname && this.isValidMsisdn && this.isValidEmail && this.isValidPostalCode
          && this.isValidHouseNumber && this.isValidAddress && this.isValidCity && !this.chooseTelcoError && this.isValidAddressAddon
      }

      return validated
    },
    createDeliveryData() {
      return {
        code: this.getSelectedCodeForRedemption,
        gender: this.gender,
        firstname: this.firstname,
        lastname: this.lastname,
        msisdn: this.msisdn,
        email: this.email,
        postalCode: this.postalCode,
        houseNumber: this.houseNumber,
        address: this.address,
        addressAddOn: this.addressAddOn,
        city: this.city
      }
    },
    //Validations
    validEmail(email) {
      return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email))
    },
    validString(name) {
      return (/^[a-zA-Z ]{2,30}$/).test(name)
    },
    validAddress(name) {
      return (/([\w\.\'\/\- ]+)/).test(name)
    },
    validPostalCode(postalCode) {
      return (/^(?:([0-9_]{4})( [a-zA-Z_]{2})|([0-9_]{4})([a-zA-Z_]{2}))$/).test(postalCode)
    },
    msisdnValidation(msisdn) {
      return (/^(06[0-9]{8}|097[0-9]{9})$/.test(msisdn))
    },
    validHouseNumber(houseNumber) {
      return (/^([0-9]{0,5})$/.test(houseNumber))
    },
    validateAddressAddon(addressAddOn) {
      return (/^.{0,5}$/.test(addressAddOn))
    },
    validNLPostalCode(name) {
      return (/^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i).test(name)
    },
    checkZipCodeFinder() {
      // check if postalCode and houseNumber are empty
      if (this.validNLPostalCode(this.postalCode) && !!this.houseNumber) {
        // if not, call the action
        this.zipCodeFinder({postCode: this.postalCode, houseNumber: this.houseNumber})
          .then((response) => {
            if (response.data !== undefined || response.data !== null) {
              this.houseNumber = response.data.deliveryData.streetNo
              this.address = response.data.deliveryData.street
              this.addressAddOn = response.data.deliveryData.address2
              this.city = response.data.deliveryData.city
            }
          })
          .catch((error) => {
            console.log('Unavailable address')
          })
      }
    }
  }
}
</script>

<style scoped>

.form-control-label, .form-control-select.select p {
  color: gray;
}

</style>



// WEBPACK FOOTER //
// src/components/DeliveryDetails.vue